import { FavoriteButton } from "@/components/Buttons";
import CardArtwork from "@/components/Card/CardArtwork";
import { CardContext } from "@/components/Card/CardContext";
import VersatileLink from "@/components/VersatileLink";
import { useSliderPosition } from "@/hooks";
import isShowValuePlanLabel from "@/lib/isShowValuePlanLabel";
import { deliveryDate, deliveryLabel, price } from "@/lib/metaUtil";
import routes from "@/lib/routes";
import styles from "@/styles/Card.module.scss";
import classnames from "classnames";
import { useCallback, useContext, useRef } from "react";

export default function EpisodeCard(props) {
  const { item, intersect, slider, rank, ...props_ } = props;
  const cardRef = useRef();
  const { classNames, active } = useSliderPosition(props_, cardRef);
  const context = useContext(CardContext);
  const channelId = Number(item?.channel?.id);
  const showValuePlanLabel = isShowValuePlanLabel({ channelId });

  const handleClick = useCallback(
    (e) => {
      if (!item.isAllowedRating) {
        e.preventDefault();
      }
    },
    [item]
  );

  return (
    <div
      ref={cardRef}
      className={classnames(classNames, {
        [styles.notAllowed]: !item.isAllowedRating,
        [styles.rankingCard]: !!rank,
      })}
    >
      <VersatileLink onClick={handleClick} href={routes.watchWithRtsid(item)}>
        <div>
          <CardArtwork
            active={active}
            index={props_.index}
            focusIndex={props_.focusIndex}
            rank={rank}
            item={item}
            intersect={intersect}
            showValuePlanLabel={showValuePlanLabel}
          />
          <div className={styles.infoContainer}>
            <div className={styles.info}>
              <div className={styles.title}>
                <p>{item.name}</p>
              </div>
              <div className={styles.delivery}>
                <span>{deliveryLabel(item)}</span>
              </div>
            </div>
            <div className={`${styles.feature}`}>
              {props_.focusIndex != null && (
                <>
                  <div className={styles.title}>
                    <p>{item.name}</p>
                  </div>
                  <div className={styles.genre}>
                    {item.genres.map((genre) => genre.name).join("/")}
                  </div>
                  <div className={styles.description}>
                    <p>{item.description}</p>
                  </div>
                  <div className={styles.delivery}>
                    <span>{deliveryLabel(item)}</span>{" "}
                    <span>{deliveryDate(item)}</span>
                  </div>
                  <div className={styles.other}>
                    {!context.hiddenPrice &&
                      item.rights &&
                      item.rights.length != 0 &&
                      price(item)}
                    {context.hiddenPrice && <span></span>}
                    <FavoriteButton
                      metaId={item.id}
                      className={styles.favorite}
                      fillGray
                      scale
                      text="お気に入り"
                    />
                  </div>
                </>
              )}
            </div>
          </div>
        </div>
      </VersatileLink>
    </div>
  );
}
